module.exports = __webpack_public_path__ + "img/15.4098f5ae.jpg";